// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../admin/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "/* Bulma Utilities */\n@media screen and (min-width: 769px) {\na[href*=\"tel:\"][data-v-19af6a2d] {\n    cursor: default;\n    pointer-events: none;\n    color: hsl(0deg, 0%, 29%);\n}\n}\n.field .help[data-v-19af6a2d] {\n  display: none;\n}\n.field--error .help[data-v-19af6a2d] {\n  display: inline-block;\n}", ""]);
// Exports
module.exports = exports;
